module.exports = __webpack_public_path__ + "static/media/notification.b2cd4d66.svg";